import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import Container from "react-bootstrap/Container";
// import './draggable.js';

export default function Education({ onClose }) {
  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window" id="dragable">
          <div class="windowheader" id="dragzone">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize"></div>
                <div class="expand"></div>
              </div>
              <div class="title">Education</div>
            </div>
          </div>

          <div class="body">
            <Container
              style={{ maxHeight: "298px", overflowY: "auto" }}
              id="style-1"
              className="scrollbar"
            >
              <div className="text education">
                <h3>B.Tech Computer Science & Engg. (2021 - 2025)</h3>
                <p>
                  SRM Institute of Science and Technology, Ramapuram
                </p>
                <ul>
                  
                    <li>Excelled the academics with a CGPA of 9.81</li>
                    <li>
                      Relevant Coursework: Data Structure and Algorithms, Design
                      and Analysis of Algorithms, Operating Systems, Computer
                      Communication, Object-Oriented Design and Programming
                    </li>
                    <li>
                      Awards and Honors: First Graduate Scholar, Winner of the
                      Codeathon
                    </li>
                  
                </ul>
                <h3>Higher Secondary Education (2019 - 2021)</h3>
                <p>
                  JaiGopal Garodia Govt.Girls Hr.Sec School, Chennai
                </p>
                <ul>
                  
                    <li>Completed the Higher secondary education with 94.5%</li>
                    <li>
                      Secured 3rd rank in the higher secondary examinations,
                      evidenced outstanding intellectual capabilities
                    </li>
                    <li>
                      Achieved Centum score in Computer Science Subject during
                      my 11th grade
                    </li>
                  
                </ul>
                <h3>Secondary Education (2018 - 2019)</h3>
                <p>
                  JaiGopal Garodia Govt.Girls Hr.Sec School, Chennai
                </p>
                <ul>
                  
                    <li>Completed the Secondary examination with 93.8%</li>
                  
                </ul>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Draggable>
  );
}
